import styled, { css } from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors, ScreenDepth } from "@ryde/theme";

export const ColumnItem = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "column-item",
})<{
  $isDragging?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: 49px;
  .col_switch {
    margin-inline-start: auto;
  }

  &.is_hidden {
    display: none;
  }

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      background-color: ${rydeColors.white};
      border-radius: 5px;
      box-shadow: 0 2px 15px rgba(0, 0, 0, 0.25);
      padding-inline-start: 5px;
      z-index: ${ScreenDepth.TABLE_SETTING_COLUMN_DRAG_CLONE};
      cursor: pointer;
    `};
`;

export const ColumnItemText = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "column-item-text",
})`
  line-height: 18.75px;
  font-weight: 500;
  font-size: 16px;
  color: ${rydeColors.black};
`;
